import styled from "styled-components";
import { Box, Typography } from "@mui/material";
import { SectionTitle } from "../SectionHeader/SectionHeader.styled";
import type { Theme } from "../../constants/themeConstants";
import BgImage from "../../assets/backgound.jpg";
import { StyledSkewedBoxWrapper } from "../SkewedTextBox/SkewedTextBox.styled";

export const StyledTenYearsSection = styled.section`
  background-image: linear-gradient(
      ${({ theme }) => (theme as Theme).colors.dark}df
    ),
    url(${BgImage});
  background-color: ${({ theme }) => (theme as Theme).colors.dark};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
`;

export const LeftSideContent = styled(Box)`
  && {
    display: flex;
    justify-content: center;
  }
`;

export const RightSideContent = styled(Box)`
  && {
    display: flex;
    flex-direction: column;
    justify-content: center;

    max-width: 720px;
    width: 100%;
    gap: 8px;

    @media (max-width: 768px) {
      gap: 8px;
    }
  }
`;

export const SectionContent = styled(Box)`
  max-width: 1216px;
  padding: 88px 32px;
  margin: 0 auto;
  position: relative;

  display: flex;
  flex-direction: row;
  column-gap: 80px;
  row-gap: 32px;

  & p {
    font-size: 1.2rem;
  }

  & ${SectionTitle} {
    font-size: 2rem;
  }

  ${StyledSkewedBoxWrapper} {
    flex-grow: 1;
  }

  @media (max-width: 768px) {
    flex-wrap: wrap;
    justify-content: flex-start;
    padding: 72px 16px;
    & p {
      font-size: 1rem;
    }

    & ${SectionTitle} {
      font-size: 1.6rem;
    }
  }
`;

export const SectionText = styled(Typography)<{ $color?: string }>`
  && {
    color: ${({ $color, theme }) =>
      $color ?? (theme as Theme).colors.textColor};
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    letter-spacing: 0;
    line-height: 100%;

    p {
      &,
      & * {
        font-family: "Roboto", "Helvetica", "Arial", sans-serif;
        font-weight: 400;
        font-size: 20px;
        line-height: 120%;
        letter-spacing: 0;
      }
    }

    h3 {
      font-family: "Roboto", "Helvetica", "Arial", sans-serif;
      font-weight: 700;
      font-size: 24px;
      line-height: 100%;
    }
  }
`;
